import "./antd.preset.css";
import { Provider } from "./EditorContext";
import empty from "./data/empty";
import "./styles.css";
import { memo } from "react";

export default memo(
  ({
    showHeader = true,
    editorRef,
    onChange,
    editorType,
    hideQuestionField = false,
    mergeTag,
    contentFormData,
  }) => {
    return (
      <div className="h5editor-app">
        <Provider
          data={empty}
          contentFormData={contentFormData}
          editorRef={editorRef}
          onChange={onChange}
          editorType={editorType}
          hideQuestionField={hideQuestionField}
          mergeTag={mergeTag}
        />
      </div>
    );
  },
);
